import { appendToUrl } from '../util';
import { getSelectedFilters, showMapboxMarkers } from './homeClubHelpers';
import { adjustMapView } from '../searchHelpers';

let storeSearchUrl = null;

const STORES_MAX = 4;
const LAPTOP_WIDTH = 1025;

const MapboxCheckout = (() => {
    const updateStoresResults = data => {
        data.stores.splice(STORES_MAX, (data.stores.length - STORES_MAX));
        const $gridDiv = $('.club-tiles-grid');
        const $landingDiv = $('.club-landing-main');
        $gridDiv.empty();
        $landingDiv.empty();
        const $clubTilesTitle = $('.club-tiles-title');
        const hasResults = data.landing ? data.groups.length > 0 : data.stores.length > 0;
        const clubfinder = $('input[name=clubfinder]').val();

        if (!hasResults) {
            $('.no-results').show();
            $clubTilesTitle.hide();
        } else {
            $('.no-results').hide();
            $clubTilesTitle.hide();
            if (data.landing) {
                if (data.storesResultsHtml) {
                    $landingDiv.append(data.storesResultsHtml);
                    MapboxCheckout.init();
                }
            } else if (data.storesResultsHtml) {
                $gridDiv.append(data.storesResultsHtml);
                $clubTilesTitle.show();
            }
        }

        const mapActive = $('#mapbox').hasClass('mapboxgl-map');

        if (mapActive) {
            const stores = data.mapStores && data.mapStores.clusters ? data.mapStores.clusters : [];
            showMapboxMarkers(stores);
        }

        if (clubfinder) {
            $(document).trigger('clubFinderResults', [hasResults]);
        }
    };

    function searchStoresbyHref(href) {
        const $form = $('.input-wrapper');
        $.ajax({
            url: href,
            type: $form.attr('method'),
            dataType: 'json',
            success(data) {
                updateStoresResults(data);
            },
        });
    }

    function showMapbox(hasResults) {
        $('.js-mapbox-map-wrapper').removeClass('display-none');
        mapboxgl.accessToken = $('#mapbox_apikey').val(); // eslint-disable-line no-undef
        const bounds = new mapboxgl.LngLatBounds( // eslint-disable-line no-undef
            new mapboxgl.LngLat(2.5, 50), // eslint-disable-line no-undef
            new mapboxgl.LngLat(10.5, 55) // eslint-disable-line no-undef
        );

        window.mapboxMap = new mapboxgl.Map({ // eslint-disable-line no-undef
            container: 'mapbox',
            style: 'mapbox://styles/mapbox/streets-v11',
            bounds,
            pitchWithRotate: false,
            dragRotate: false,
            id: 'symbols',
            maxZoom: 16,
            touchZoomRotate: true,
        });

        if ($(window).width() < LAPTOP_WIDTH) {
            window.mapboxMap.dragPan.disable();
        }

        window.mapboxMap.addControl(new mapboxgl.NavigationControl()); // eslint-disable-line no-undef
        window.mapboxMap.on('load', () => {
            adjustMapView(window.mapboxMap);
        });

        if (hasResults) {
            $.ajax({
                url: storeSearchUrl,
                type: 'get',
                dataType: 'json',
                success: data => {
                    const stores = data.mapStores && data.mapStores.clusters ? data.mapStores.clusters : [];
                    showMapboxMarkers(stores);
                },
            });
        }
    }

    function loadAndShowMapbox(hasResults) {
        if (typeof mapboxgl === 'object') {
            showMapbox(hasResults);
        } else {
            $('<link/>', { rel: 'stylesheet', type: 'text/css', href: '//api.tiles.mapbox.com/mapbox-gl-js/v1.3.1/mapbox-gl.css' }).appendTo('head');
            $.getScript('//api.tiles.mapbox.com/mapbox-gl-js/v1.3.1/mapbox-gl.js', () => showMapbox(hasResults));
        }
    }

    function addClubToCart(pid, addSubscriptionUrl, subscriptionMembershipUrl) {
        const form = {
            pid,
            quantity: 1,
        };

        if (addSubscriptionUrl) {
            $.ajax({
                url: addSubscriptionUrl,
                method: 'POST',
                data: form,
                success: (data) => {
                    if (!data.error && subscriptionMembershipUrl) {
                        window.location.replace(subscriptionMembershipUrl);
                    }
                },
            });
        }
        return false;
    }

    const initEvents = () => {
        $('.club-landing-main').on('click', '.js-see-all', e => {
            const href = $(e.currentTarget).attr('href');
            const name = $(e.currentTarget).attr('name');
            const $quickFilter = $(`.js-filter-button[name="${name}"]`);

            if ($quickFilter.length > 0) {
                $quickFilter.addClass('selected');
            }

            searchStoresbyHref(href);
            history.replaceState(null, null, href);
            return false;
        });

        $('.js-user-location').on('click', () => {
            $('.js-no-location').removeClass('display-none');
            const mapActive = $('#mapbox').hasClass('mapboxgl-map');
            let locationUrl = $('.js-no-location').data('url');

            if (mapActive) {
                const callback = position => {
                    const lat = position.coords.latitude;
                    const long = position.coords.longitude;
                    const locationParams = {
                        latitude: lat,
                        longitude: long,
                        checkout: true,
                    };

                    locationUrl = appendToUrl(locationUrl, locationParams);

                    $.ajax({
                        url: locationUrl,
                        type: 'POST',
                        dataType: 'json',
                        success(data) {
                            if (!data.error) {
                                $('.js-no-location').addClass('display-none');
                                window.mapboxMap.flyTo({
                                    center: [position.coords.longitude, position.coords.latitude],
                                    zoom: 9,
                                });
                            }
                        },
                    });
                };

                const showError = error => {
                    if (error.code === 1) {
                        window.alert('Please, check your browser settings and make sure to allow your location'); // eslint-disable-line no-alert
                        $('.js-no-location').addClass('display-none');
                    } else {
                        $('.js-no-location').removeClass('display-none');
                    }
                };

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(callback, showError);
                }
            }
        });

        $('.js-mapbox-link').click(e => {
            e.preventDefault();
            const clubfinder = $('input[name=clubfinder]').val();
            const eventName = clubfinder ? 'clubFinderViewMapClicked' : 'subscriptionViewMapClicked';
            storeSearchUrl = $(e.currentTarget).data('action-url');
            const searchTerm = $('input[name=searchterm]').val();
            const filterIds = getSelectedFilters();
            const urlParams = {
                searchterm: searchTerm,
                filters: filterIds,
                checkout: true,
            };

            $(e.currentTarget).addClass('map-active');

            const token = '&map=true';
            $('.js-filter-button').each((i, event) => {
                const href = $(event).prop('href');
                if (href.indexOf(token) === -1) {
                    $(event).prop('href', `${href}${token}`);
                }
            });

            $(document).trigger(eventName);
            storeSearchUrl = appendToUrl(storeSearchUrl, urlParams);
            loadAndShowMapbox();
        });

        $('#mapbox_club').click(e => {
            e.preventDefault();
            const mapData = $('#mapbox_club').data();
            const urlParams = {
                pid: mapData.pid,
            };

            storeSearchUrl = appendToUrl(mapData.actionUrl, urlParams);
            loadAndShowMapbox();
        });

        $('#mapbox_newclub').click(e => {
            e.preventDefault();
            const mapData = $('#mapbox_newclub').data();
            const urlParams = {
                pid: mapData.pid,
            };

            storeSearchUrl = appendToUrl(mapData.actionUrl, urlParams);
            loadAndShowMapbox();
        });

        $('.js-store-tile-close').click(e => {
            e.preventDefault();
            $(e.currentTarget).parent().css('display', 'none');
        });

        $('body').on('click', '.js-store-tile-cta', () => {
            const $store = $('.js-store-tile');
            const productID = $store.data('pid');
            const addProductUrl = $store.data('add-product-url');
            const subscriptionMembershipUrl = $store.data('subscription-membership-url');

            addClubToCart(productID, addProductUrl, subscriptionMembershipUrl);
        });

        $('.js-stores-map-close').click(() => {
            $('.js-stores-map-wrapper').addClass('display-none');
        });

        $('.js-mapbox-map-close').click(() => {
            $('.js-mapbox-map-wrapper').addClass('display-none');
            $('.js-mapbox-link.map-active').removeClass('map-active');

            const token = '&map=true';
            $('.js-filter-button').each((i, e) => {
                const href = $(e).prop('href');
                if (href.indexOf(token) !== -1) {
                    $(e).prop('href', `${href.replace(token, '')}`);
                }
            });
        });
    };

    function scrollOnClick() {
        $(document).ready(() => {
            $('.content-link').click(e => {
                e.preventDefault();

                $('html, body').animate({
                    scrollTop: $('#mapbox').offset().top,
                }, 500);
            });
        });
    }

    function checkAndShowMap(hasResults) {
        const $form = $('.input-wrapper');
        storeSearchUrl = $form.attr('action');
        const searchterm = $('input[name=searchterm]').val();
        const filters = getSelectedFilters();
        const searchUrlParams = {
            searchterm,
            filters,
            checkout: true,
        };

        storeSearchUrl = appendToUrl(storeSearchUrl, searchUrlParams);

        loadAndShowMapbox(hasResults);
        $('.js-no-location').removeClass('display-none');
    }

    return {
        init(hasResults) {
            initEvents();
            scrollOnClick();
            checkAndShowMap(hasResults);
        },
    };
})();

export default MapboxCheckout;
